export enum LoginErrorCodes {
	wrongapk = 600301,
	temporaryLockCode = 400168,
	temporaryLockedWithDurationCode = 400166,
	dataConfirmationRequiredCode = 400213,
	matchingAvailable = 400218,
	CPRNumberNotRegistered = 400901,
	CPRNumberVerificationError = 400902,
	loginExclusionCheckError = 400904,
	loginIndefiniteExclusion = 400905,
	loginTemporaryExclusion = 400906,
	playerTooYoung = 400907,
	spelpausGamingExclusionActive = 400228,
	lugasPlayerNotRegistered = 400243,
	lugasValidationError = 400242,
	lugasDown = 400245,
	lugasUnspecified = 400256,
	userLocked = 400111,
	unableToLogin = 400101,
	lastTryLogin = 400110,
	userNotApproved = 400112,
	userNotExist = 400102,
	organizationalStructureDisabled = 400103,
	invalidPassword = 400113,
	userNotVerified = 400202,
	oasisGamingExclusion = 400197,
	lugasPlayerInWaitingPeriod = 400253,
	lugasPlayerActiveOnDifferentProvider = 400251,
	gamesNotAllowed = 40414,
	loginDisabledLugasDown = 400296,
	loginDisabledOasisDown = 400279,
}
